import { userRolesFilter } from 'user/utils/filter';
import { IFilterFormItem, IFilterPermissions } from 'common/types';
import {
    startDateRangeFilter,
    trainingsFilter,
    userGroupsFilter,
} from 'common/utils/drawerFilters';

export function getUserFilters(
    permissions?: IFilterPermissions,
    showEmptyFilterOptions = true,
    hasUserActivity = false,
    groupPriorityIds?: string[]
): IFilterFormItem[] {
    return [
        userRolesFilter(undefined, undefined, permissions?.rolesFilter),
        userGroupsFilter(undefined, 'groupIds', undefined, {
            noGroupsOption: showEmptyFilterOptions,
            priorityIds: groupPriorityIds,
        }),
        trainingsFilter(undefined, 'trainingIds', {
            noTrainingsOption: showEmptyFilterOptions,
        }),
        hasUserActivity
            ? startDateRangeFilter(
                  'drawerFilters.activityDateRange',
                  'activityFrom',
                  'activityTo'
              )
            : startDateRangeFilter(
                  'drawerFilters.lastLoginDateRange',
                  'lastLogin_Gt',
                  'lastLogin_Lt'
              ),
    ] as IFilterFormItem[];
}
